import axios from 'axios';
import auth from './auth.service';
import router from '../../shared/router';

const HTTP_UNAUTHORIZED = 401;
const HTTP_NOT_ALLOWED = 405;
const HTTP_BAD_REQUEST = 400;
const HTTP_NOT_FOUND = 404;
const HTTP_INTERNAL_SERVER_ERROR = 500;

if (!VUE_APP_CLIENT_ID) {
}

/** Default config for axios instance */
const config = {
  baseURL: VUE_APP_NODE_SERVER_URL,
};

/** Creating the instance for axios */
const axiosClient = axios.create(config);

/** Auth token interceptors */
const authInterceptor = async (config) => {
  const expireTime = auth.getTokenExpireDate();
  //Renew access token if expired
  if (Date.now() >= expireTime) {
    await auth.retrieveAccessToken(false);
  }


  config.headers.Authorization = `Bearer ${auth.getToken()}`;
  return config;
};

/** Adding the request interceptors */
axiosClient.interceptors.request.use(authInterceptor);

/** Adding the response interceptors */
axiosClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Here, instead of handling errors, let them propagate by throwing
    if (error.response) {
      const { status } = error.response;

      // Handle specific status codes if needed, for example:
      if (status === 401) {
        // Logout user, clear local storage, or redirect to login, etc.
        // Be careful with potentially causing redirect loops or similar issues.
        // auth.logout();
        // router.push('/login');
      }

      error.customMessage = 'An error occurred with the request.';

      throw error;
    }

    throw error;
  },
);

function runRequest(requestType, url, data, options) {
  return new Promise(async (resolve) => {
    const resolveObj = {
      success: true,
      body: null,
      errors: [],
      error: null,
    };

    const currentTime = new Date().getTime();
    const tokenExpireDate = localStorage.getItem('ACCESS_TOKEN_EXPIRES');

    if (parseInt(tokenExpireDate) < parseInt(currentTime)) {
      await auth.retrieveAccessToken(false);
    }


    try {
      const response = await axiosClient[requestType](url, data, options);
      resolve(handleSuccessResponse(response, resolveObj));
    } catch (data) {
      resolve(handleExceptionResponse(data.response, resolveObj));
    }
  });
}

function handleSuccessResponse(response, resolveObj) {
  resolveObj.success = true;
  resolveObj.body = response.data;
  resolveObj.response = response;
  return resolveObj;
}


function handleExceptionResponse(response, resolveObj) {
  resolveObj.success = false;
  resolveObj.body = response.data;
  resolveObj.response = response.response;

  if (response.status === HTTP_UNAUTHORIZED) {
    // auth.logout();
    localStorage.clear();
    try{
      router.push('/login');
    } catch(e) {
    }

  } else if (response.status === HTTP_NOT_ALLOWED) {
    resolveObj.error = 'Requested method is not allowed.';
  } else if (response.status === HTTP_BAD_REQUEST) {
    //todo improve error parsing

    for (const key in response.body) {
      const innerData = response.body[key];
      // This means that inner data is an array
      if (innerData.length !== undefined) {
        innerData.forEach((error) => {
          resolveObj.errors.push(error);
        });
      }
    }
  } else if (response.status === HTTP_NOT_FOUND) {
    resolveObj.error = 'Requested data was not found.';
  } else if (response.status === HTTP_INTERNAL_SERVER_ERROR) {
    resolveObj.error = 'Internal server error.';
  } else {
    resolveObj.error = 'Something went wrong.';
  }

  return resolveObj;
}

const http = {
  get: (url, data, options) => runRequest('get', url, data, options),
  put: (url, data, options) => runRequest('put', url, data, options),
  patch: (url, data, options) => runRequest('patch', url, data, options),
  post: (url, data, options) => runRequest('post', url, data, options),
  delete: (url, data, options) => runRequest('delete', url, data, options),
};

export {
  http as axiosClient,
};
